export const CHART_WIDTH_FOR_PDF = '1430px';
